import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    container: {
        overflowY: 'scroll',
        overflowX: 'hidden',
        flexGrow: 1,
        position: 'relative',
    },
    dialogList: {
        marginBottom: '10px',
    },
    messageContainer: {
        position: 'relative',
        '&:hover .hover-actions': {
            opacity: 1,
        },
        '&.response': {
            '&:hover': {
                borderLeftColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.8)),
            },
        },
        borderLeft: '1px solid',
        borderLeftColor: `transparent`,
        '&.itemSelected': {
            borderLeft: '1px solid',
            borderLeftColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.4)),
            backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.08)),
        },
    },
    dataSource: {
        position: 'relative',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        overflow: 'hidden',
        pl: '56px',
        top: '-15px',
    },
    hoverActionContainer: {
        opacity: 0,
        position: 'absolute',
        inset: '0 0 0 0',
        fontSize: '14px',
        color: 'primary.main',
        whiteSpace: 'nowrap',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        pointerEvents: 'none',
        transition: `opacity 0.4s ease-in-out`,
        backgroundColor: `transparent`,
    },
    hoverAction: {
        position: 'relative',
        bottom: '0px',
        left: '40px',
        pb: '4px',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'auto',
        cursor: 'pointer',
        width: '65px',
        backgroundColor: `transparent`,
    },
    hoverActionIcon: {
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.24),
        '&:hover': {
            color: (theme: Theme) => theme.palette.primary.main,
        },
    },
    showThinkingButton: {
        marginRight: '16px',
        fontSize: '12px',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.24),
        cursor: 'pointer',
        pb: '8px',
        pointerEvents: 'auto',
        '&:hover': {
            color: (theme: Theme) => theme.palette.primary.main,
        },
    },
    divider: {
        width: '2px',
        height: '32px',
        backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
    },
};
